"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Sarah Chen",
  quote: "\"R&B Solutions\xA0transformed our legacy architecture into a high-performance cloud ecosystem. Their technical precision is unmatched.\"",
  position: "CTO, Nexus Systems",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_sarah_chen.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_sarah_chen.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_sarah_chen.png-wvc-sizes"
  }
}, {
  author: "Marcus Thorne",
  quote: "The agile methodology they employ ensured our product hit the market three months ahead of schedule. A true engineering partner.",
  position: "Founder, Velocity AI",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_marcus_thorne.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_marcus_thorne.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/client_marcus_thorne.png-wvc-sizes"
  }
}];
export default function GuestExperiences() {
  return;
}